<template>
  <v-tooltip v-bind="tooltipOptions" :disabled="!enabled">
    <template #activator="{ on }">
            <span v-on="on" :class="{hidden: !enabled }">
                <slot></slot>
            </span>
    </template>
    <span v-html="tooltipText"></span>
  </v-tooltip>
</template>
<script>

export default {
  data: () => ({
    show: false,
  }),
  props: {
    tooltip: {
      type: Object,
      required: false,
      default: () => {
      },
    },
    enabled: {
      type: Boolean,
      required: true,
      default: false,
    },
    tooltipText: {
      type: String,
      required: true,
    }
  },
  computed: {
    tooltipOptions() {
      const defaults = {
        'top': true,
        'bottom': false,
        'attach': false,
        'offset-overflow': true,
        'lazy': true,
        ...this.tooltip,
      };

      return {
        'close-delay': 2000,
        'max-width': 300,
        ...defaults,
      };
    },
  },
};
</script>